import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LogService, ServiceRouter } from '@pershing/pershing-core';
import { PortalComponentServiceDefinition } from './portal-component-service-definition';
import { Observable } from 'rxjs';

@Injectable()
export class PortalComponentService {
    public serviceUrl: string;
    constructor(private http: HttpClient, private logService: LogService, private serviceRouter: ServiceRouter) {
        logService.info('NxiRestService : constructor Initializing');
        this.serviceUrl = this.serviceRouter.getServiceRouteURL(PortalComponentServiceDefinition.getInstance());
        window['nxiRestServiceUrl'] = '/' + this.serviceUrl; // Setting nxiRestServiceUrl to the window object so that it can be used in the dojo widgets directly
        // this.serviceUrl = 'http://dev-advisor-netxinvestor.bnymellon.net:8081/test-netxinvestor-rest-service-qa-app/services/netxclient.rest-service';
        logService.info('NxiRestService : URL', this.serviceUrl);
    }
    public getLastLoginTime(ibd: string, userId: string): Observable<any> {
        let timeNow = Date.now();
        return this.http.get(this.serviceUrl + '/portfolio/get-user-response?userId=' + userId + '&ibd=' + ibd + '?time=' + timeNow);
    }

}
